module.exports = {
  "country": "LU",
  "artist": "Jean-Claude Pascal",
  "song": "Nous Les Amoureux",
  "year": "1961",
  "place": "1",
  "spotify": "4Arm9XIIsLfL0PYhtSd2mV"
};